import { baseApi } from '@app/store/index.api';

import {
  IChangeTraderSettingsQuery,
  IChangeTraderSettingsResponse,
  IChangeTraderTrustLevelQuery,
  IChangeTraderTrustLevelResponse,
  ITraderResponse,
  ITrustLevel,
  ITrustLevelsResponse,
} from '../model/types';

const traderApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getTraders: builder.query<ITraderResponse, string>({
      query: query => {
        return {
          url: `pd/traders?${query}`,
        };
      },
    }),
    getTrustLevels: builder.query<ITrustLevelsResponse, void>({
      query: () => {
        return {
          url: 'pd/traders/trust-levels',
        };
      },
      transformResponse: (response: { data: ITrustLevel[] }) => response.data,
    }),
    changeTraderTrustLevel: builder.mutation<
      IChangeTraderTrustLevelResponse,
      IChangeTraderTrustLevelQuery
    >({
      query: ({ id, trust_level_id }) => ({
        url: `/pd/traders/${id}/trust-level`,
        method: 'PATCH',
        body: { trust_level_id },
      }),
    }),
    changeTraderSettings: builder.mutation<
      IChangeTraderSettingsResponse,
      IChangeTraderSettingsQuery
    >({
      query: ({ id, field, value }) => ({
        url: `/pd/traders/${id}/settings`,
        method: 'PUT',
        body: { [field]: value },
      }),
    }),
  }),
});

export const {
  useGetTradersQuery,
  useGetTrustLevelsQuery,
  useChangeTraderTrustLevelMutation,
  useChangeTraderSettingsMutation,
} = traderApi;
